import { LINKS } from "utils/constants";

export const SOURCE_REDIRECTS: Record<string, string> = {
  mail: LINKS.PLAYSTORE,
};

export const redirectBySource = (
  search: string = window.location.search
): boolean => {
  const source = new URLSearchParams(search).get("source");
  const target = source ? SOURCE_REDIRECTS[source.trim().toLowerCase()] : undefined;

  if (!target) return false;

  window.location.replace(target);
  return true;
};
